import React from 'react';
import DepreciationReport from './DepreciationReport';

const FADepreciationReport = () => {
  return <DepreciationReport type="full-report" />;
};

export default FADepreciationReport;
